export const REF_NAME = '';
export const COMMIT_SHA = 'c5e97b1';
export const PIPELINE_ID = '';
export const BUILD_DATE = 'Mo 18. Nov 10:46:04 UTC 2024';
